import { safeAuthFetch } from '../utils/safeFetch';
import { API_BASE_URL } from '../config/api.js';

/** POST a natural-language question to surface C. Returns the parsed 200 body
 *  ({kind:'answer'|'overview'|'clarify'|'unsupported'|'report_suggested', ...} — Task 13,
 *  #1660; the backend no longer emits 'cannot_answer'). Non-2xx throws a FetchError
 *  (caught by the caller; 403 → disabled state). The FAB is flag-gated so 403 is rare. */
export async function askAnalytics(question) {
  const res = await safeAuthFetch(`${API_BASE_URL}/api/analytics/ask`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ question }),
  });
  return res.json();
}
